export default __webpack_public_path__ + "static/media/house-3.a6a5216c.jpg";